import styled from 'styled-components'

export const ContentTag = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 4px;
`
